import React, { useEffect } from 'react';
import HeaderAuth from '../../components/HeaderAuth/HeaderAuth';
import RegisterSimilar from '../../components/Registration/RegisterSimilar/RegisterSimilar';

const RegisterSimilarPage = () => {
  useEffect(() => {
    document.body.removeAttribute('class');
    document.title = 'Знайдено схожий профіль | New Brain';
  }, []);

  return (
    <div>
      <HeaderAuth />
      <section className='container container--login'>
        <RegisterSimilar />
      </section>
    </div>
  );
};

export default RegisterSimilarPage;